import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AddZileLibere, EditZileLibere } from './zile-libere';

@Injectable({
  providedIn: 'root',
})
export class ZileLibereService {
  private token!: string;
  private httpOptions: any;

  private basePath = environment.interop.basePath;
  //Getters
  private getZLList =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.zileLibere.getZileLibereList;
  private postZLDT =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.zileLibere.getZileLibereListDT;

  //Update
  private storeZLURL =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.zileLibere.storeZileLibere;
  private putZLURL =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.zileLibere.updateZileLibere;

  //Delete
  private deleteZLURL =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.zileLibere.deleteZileLibere;

  constructor(private http: HttpClient) {}

  getZileLibereDT() {
    return this.http.get(this.getZLList, this.httpOptions);
  }

  addZileLibere(zileLibere: AddZileLibere) {
    return this.http.post(this.storeZLURL, zileLibere, this.httpOptions);
  }

  updateZileLibere(zileLibere: EditZileLibere) {
    return this.http.put(this.putZLURL, zileLibere, this.httpOptions);
  }

  deleteZileLibere(zileLibereId: number) {
    return this.http.delete(this.deleteZLURL + zileLibereId);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
